import { render } from "./ProbabilityPreview.vue?vue&type=template&id=c1cc37a8&scoped=true&ts=true"
import script from "./ProbabilityPreview.vue?vue&type=script&lang=ts"
export * from "./ProbabilityPreview.vue?vue&type=script&lang=ts"

import "./ProbabilityPreview.vue?vue&type=style&index=0&id=c1cc37a8&scoped=true&lang=css"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1cc37a8"]])

export default __exports__